export default __webpack_public_path__ + "static/media/cloud-download.344db5d7.svg";